<template>
  <table class="table table-striped my-4">
    <thead class="thead-dark">
      <tr>
        <th v-for="(sortColumn, index) in sortColumns()" :key="'sort-column-' + index" class="p-0">
          <button @click.prevent="sort(sortColumn)" class="btn btn-table-sort">
            <span>{{ $t('views.reservations.sortColumns.' + sortColumn) }}</span>
            <span class="hide-in-print icon icon-navigation_pfeil_unten" aria-hidden="true" v-if="sortOptions.column ===sortColumn && sortOptions.sortOrder==='asc'"></span>
            <span class="hide-in-print icon icon-navigation_pfeil_oben" aria-hidden="true" v-if="sortOptions.column ===sortColumn && sortOptions.sortOrder==='desc'"></span>
            <span class="hide-in-print icon icon-filter" aria-hidden="true" v-if="sortOptions.column !==sortColumn"></span>
          </button>
        </th>
        <th class="hide-in-print table-width-100" v-if="searchType !== 'CANCELLED'">
          {{ $t('views.reservations.action') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(ticket, index) in tickets" :key="index">
        <td>{{ shortRoomName(ticket.roomName)}}</td>
        <td>{{ ticket.lastName }}<span v-if="ticket.lastName && ticket.firstName">,</span> {{ ticket.firstName }}</td>
        <td>{{ ticket.organisation }}</td>
        <td>{{ ticket.email }}</td>
        <td>{{ formatTicketTime(ticket) }}</td>
        <td class="hide-in-print table-width-100" v-if="searchType !== 'CANCELLED'">
          <div class="d-flex justify-content-center aling-items-center" v-if="ticket.lastName && ticket.firstName">
            <link-default i18nMessage="common.ticketEdit" :to="{ name: 'admin-reservation-edit', params: { id: ticket.id }, query: { 'fromSearch': 'y' } }" :iconOnly="true" iconClass="icon-editieren" class="d-block align-self-center" v-if="isEditable(ticket)" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { Ticket, TicketStatusEnum } from '@/generated/openapi';
import { formatTicketTime } from '@/utils/formatUtils';
import { defineComponent, PropType } from 'vue'
import LinkDefault from '../interaction/LinkDefault.vue';
import { createTicketSortOptions, SortOptions, TICKET_SORT_VALUES } from '@/models/SortOptions'
import { GuiOptions } from '@/models/GuiOptions';
import config from '@/config/config';

export default defineComponent({
  name: 'ResultListTickets',
  components: { LinkDefault },
  props: {
    tickets: {
      type: Array as PropType<Ticket[]>,
      required: true
    },
    sortOptions: {
      type: Object as PropType<SortOptions>,
      required: true
    },
    searchType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isAdmin: config.interface === GuiOptions.admin
    }
  },
  methods: {
    isEditable(ticket: Ticket): boolean {
      return this.isAdmin && ticket.status === TicketStatusEnum.Booked
    },
    sortColumns() {
      return Object.keys(TICKET_SORT_VALUES)
    },
    formatTicketTime(ticket: Ticket) {
      return formatTicketTime(ticket)
    },
    sort(sortColumn: string) {
      this.$emit('sortChanged', createTicketSortOptions(sortColumn, sortColumn === this.sortOptions.column ? (this.sortOptions.sortOrder === 'asc') : false))
    },
    shortRoomName(roomname:string){
      if (roomname.length <= 18) {
        return roomname
      }
      return roomname.slice(0, 18) + ' ...'
    }
  }
});
</script>
